<div class="flex flex-col basis-full">
  @if(noPermission) {
    <div class="flex flex-row display">
      <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
      <div class="flex flex-col items-center mb-32">
        <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color mt-16"></mat-icon>
        <div class="fw-600 fs-20 mt-16 mb-32 text-center">{{title}}</div>
        <div class="flex flex-row justify-center items-center mt-16">
          <button class="white mr-20" type="button" (click)="matdialogRef.close()">{{ 'BUTTONS.CANCEL' | transloco }}</button>
          <button class="error-report-bg-color accent" type="button" (click)="openContactForm()">{{ 'ERROR_DIALOG.REPORT' | transloco }}</button>
        </div>
      </div>
    </div>
  } 
  @if(restoreError) {
  <div class="flex flex-row display">
    <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
    <div class="flex flex-col items-center mb-32">
      <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color mt-16"></mat-icon>
      <div class="fw-600 fs-18 mt-16 mb-16 text-center">{{title}}</div>
      <div class="p-16 blue-bg w-100-percent mb-16">
        <span class="mr-4 fw-600 fs-16">{{ 'ERROR_DIALOG.MESSAGE' | transloco }} </span>
        <span class="fw-400 fs-14">{{description}}</span>
      </div>
      <mat-divider class="w-100-percent full-width-divider ml-20 mb-16"></mat-divider>
      <div class="flex flex-row justify-center items-center ml-auto mb--20">
        <button class="white mr-20 report-letter-spacing" type="button" (click)="matdialogRef.close()">{{ 'BUTTONS.CANCEL' | transloco }}</button>
        <button class="error-report-bg-color accent report-letter-spacing" type="button" (click)="openContactForm()">{{ 'ERROR_DIALOG.RAISE_TICKET' | transloco }}</button>
      </div>
    </div>
  </div>
  }
  @else {
  <div class="flex flex-row display" *ngIf="!internalError">
    <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
    <div class="flex flex-col items-center">
      <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
      <div *ngIf="!alertError" class="fw-700 fs-24 failed-title mt-16 mb-16">{{title}}</div>
      <div *ngIf="alertError" class="fw-400 fs-16 mt-20 mb-12" [innerHtml]="title"></div>
      <div *ngIf="alertError" class="p-16 ml-8 blue-bg mr--16 mb-12">
        <span class="mr-4 fw-600">{{ 'ERROR_DIALOG.MESSAGE' | transloco }}</span>
        <span class="description-text mr-4 fw-400 fs-16" [title]="description" [innerHtml]="description"></span>
      </div>
       @if(scheduleDescription){
          <div class="flex flex-col justify-center items-center w-100-percent">
            <span class="description-text mr-4 fw-400 fs-16" [innerHtml]="scheduleDescription"></span>
            <span class="description-text mr-4 fw-400 fs-16 cooling-period" [innerHtml]="coolingPeriod"></span>
          </div>
        }
      <div class="flex flex-row w-100-percent">
        <div *ngIf="newDescription" class="flex justify-center items-center w-100-percent new-description-response">
          <span class="description-text mr-4 fw-600 fs-16" [title]="newDescription">{{ newDescription }}</span>
        </div>
        <div *ngIf="descriptionArray" class="flex justify-center items-center w-100-percent fw-500 fs-16 failed-description-response mt-16"><span class="description-text mr-4 fs-14" [title]="description">{{ description }}</span>
        </div>
        <div *ngIf="((errorDesc && isErrorDescription )|| (errorArray && errorArray.length > 0))" class="flex justify-center items-center w-100-percent fw-500 fs-16 failed-description-error mt-4"><span class="description-text mr-4 fs-14" [title]="descriptionError">{{ descriptionError }}</span>
        </div>
      </div>
      <div *ngIf="(descriptionArray || description) && !alertError" class="w-100-percent">
        <button class="flex justify-end h-30 error-copy-class pt-4 pr-8 pb-4 pl-8" [ngClass]="[copy ? 'copied': 'copy']" (click)="descriptionArray?copyText(descriptionArray,'descriptionList'):copyText(description,'description')">
          <span *ngIf="!copy" class="fs-16 fw-500 item flex items-center">
            <mat-icon class="h-18 w-18 mr-6" svgIcon="content_copy"></mat-icon>{{ 'ERROR_DIALOG.COPY' | transloco }}
          </span>
          <span *ngIf="copy" class="fs-16 fw-500 item flex items-center copied-text">
            <mat-icon class="h-18 w-18 mr-6" svgIcon="check"></mat-icon>{{ 'ERROR_DIALOG.COPIED' | transloco }}
          </span>
        </button>
      </div>
      <div *ngIf="description && !descriptionArray && source && target" class="w-100-percent fw-500 fs-16 failed-description-response mt-16 scrollable-container p-16 src-tgt-error ml-20 mb-16"><span class="mr-4 fs-14" [title]="description">{{ description }}</span>
        <div><span class="fw-700 mr-4">{{ 'ERROR_DIALOG.SOURCE' | transloco }}</span>{{source}}</div>
        <div><span class="fw-700 mr-4">{{ 'ERROR_DIALOG.TARGET' | transloco }}</span>{{target}}</div>
      </div>
      <div *ngIf="description && !descriptionArray && !source && !target && !alertError" class="flex justify-center items-center w-100-percent fw-500 fs-16 failed-description-response mt-16 scrollable-container popup-class p-16"><span class="singleline-text mr-4 fs-14" [title]="description">{{ description }}</span></div>
      <div *ngIf="((errorDesc && isErrorDescription )|| (errorArray && errorArray.length > 0))" class="w-100-percent">
        <button class="flex justify-end h-30 error-class pt-4 pr-8 pb-4 pl-8" [ngClass]="[copy ? 'copied': 'copy']" *ngIf="errorArray || errorDesc" (click)="errorDesc ? copyError(errorDesc, 'singleMsg') : copyError(errorArray)">
          <span *ngIf="!copy" class="fs-16 fw-500 item flex items-center">
            <mat-icon class="h-18 w-18 mr-6" svgIcon="content_copy"></mat-icon>{{ 'ERROR_DIALOG.COPY' | transloco }}
          </span>
          <span *ngIf="copy" class="fs-16 fw-500 item flex items-center copied-text">
            <mat-icon class="h-18 w-18 mr-6" svgIcon="check"></mat-icon>{{ 'ERROR_DIALOG.COPIED' | transloco }}
          </span>
        </button>
      </div>
      <mat-divider></mat-divider>
      <div *ngIf="descriptionArray" class="overflow-class w-100-percent pr-16 pt-0 pb-16 pl-16" >
        <div *ngFor="let description of descriptionArray; let i = index">
          <p>
            <span class="error-text">{{ ('ERROR_DIALOG.ERROR' | transloco) + ' ' + (i + 1) + ': ' }}</span><span class="value-text">{{description.message}}</span>
          </p>
        </div>
      </div>
      <div *ngIf="errorArray && errorArray.length > 0" class="scrollable-container popup-class w-100-percent p-16" >
        <div *ngFor="let item of errorArray; let index = index">
          <p>
            <span *ngIf="item?.code" class="popup-text">{{ 'ERROR_DIALOG.CODE' | transloco }}</span><span class="value-text"> {{ item?.code }}</span><span *ngIf="item?.code && (item?.message || item?.details || item?.source)"><br></span>
            <span *ngIf="item?.message" class="popup-text">{{ 'ERROR_DIALOG.MESSAGE' | transloco }}</span><span class="value-text"> {{ item?.message }}</span><span *ngIf="item?.message && (item?.details || item?.source)"><br></span>
            <span *ngIf="item?.details" class="popup-text">{{ 'ERROR_DIALOG.DETAILS' | transloco }}</span><span class="value-text"> {{ item?.details }}</span><span *ngIf="item?.details && item?.source"><br></span>
            <span *ngIf="item?.source" class="popup-text">{{ 'ERROR_DIALOG.SOURCE' | transloco }}</span><span class="value-text"> {{ item?.source }}</span>
          </p>
          <mat-divider *ngIf="index < errorArrayLength - 1" class="popup-divider mt-4 mb-8"></mat-divider>
        </div>
      </div>
      <div *ngIf="errorDesc && isErrorDescription" class="scrollable-container popup-class w-100-percent p-16" >
        <p>
          <span *ngIf="errorDesc?.code" class="popup-text">{{ 'ERROR_DIALOG.CODE' | transloco }}</span><span class="value-text"> {{ errorDesc?.code }}</span><span *ngIf="errorDesc?.code && (errorDesc?.message || errorDesc?.details || errorDesc?.source)"><br></span>
          <span *ngIf="errorDesc?.message" class="popup-text">{{ 'ERROR_DIALOG.MESSAGE' | transloco }}</span><span class="value-text"> {{ errorDesc?.message }}</span><span *ngIf="errorDesc?.message && (errorDesc?.details || errorDesc?.source)"><br></span>
          <span *ngIf="errorDesc?.details" class="popup-text">{{ 'ERROR_DIALOG.DETAILS' | transloco }}</span><span class="value-text"> {{ errorDesc?.details }}</span><span *ngIf="errorDesc?.details && errorDesc?.source"><br></span>
          <span *ngIf="errorDesc?.source" class="popup-text">{{ 'ERROR_DIALOG.SOURCE' | transloco }}</span><span class="value-text"> {{ errorDesc?.source }}</span>
        </p>
      </div>
      @if (errorDetails?.length) {
        <div class="flex flex-col popup-class w-100-percent error-info">
          @for (group of errorDetails; track group.recordIndex; let isLast = $last) {
            @let component =  group.component;
            <span class="popup-text">{{ 'ERROR_DIALOG.COMPONENT_NAME' | transloco }}:<span class="value-text"> {{ group.component}}</span></span>
            @for (parent of group.parents; track parent.parentKey;let  j= $index) {
              @let parentKey = parent.parentKey;
                <span class="popup-text"> {{ 'ERROR_DIALOG.SOURCE_TITLE' | transloco }}{{j+1}}:<span class="value-text"> {{ parent.parentKey === '' ? component : parent.parentKey}}</span></span>
              @for (error of parent.errors; track error.key; let i = $index) {
                <span class="popup-text">{{ 'ERROR_DIALOG.FIELD'| transloco }}{{i+1}}:<span class="value-text"> {{error.field && error.field !== parentKey ? error.field : error.key}}</span></span>
                <span class="popup-text">{{ 'ERROR_DIALOG.MESSAGE' | transloco }}<span class="value-text"> {{ error.message }}</span></span>
              }
            }
            @if(!isLast) {
              <mat-divider class="popup-divider mt-4 mb-8"></mat-divider>
            }
          }
        </div>
      }
    </div>
  </div>
  <div class="flex flex-row display" *ngIf="internalError">
    <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
    <div class="flex flex-col items-center mb-38 mt-16">
      <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color"></mat-icon>
      <div *ngIf="title" class="fw-700 fs-24 failed-title mt-16 mb-16">{{title}}</div>
      <div *ngIf="description" class="mat-subtitle-2 fs-16 fs-600 mt-2">{{description}}</div>
      <div *ngIf="note" class="mat-subtitle-2 fs-14 fs-500 mt-16 failed-description-response popup-class p-16">{{note}}</div>
    </div>
    <mat-divider class="w-100-percent full-width-divider ml--24 mb-16"></mat-divider>
    <div class="flex items-center justify-center">
      <button class="accent report-letter-spacing" type="button" (click)="matdialogRef.close()"> {{ 'BUTTONS.CLOSE' | transloco }} </button>
    </div>
  </div>
<div *ngIf="(newDescription || description || scheduleDescription) && !alertError && !internalError && !descriptionArray && !errorArray" class="flex flex-col justify-center items-center mt-20">    
    <mat-divider class="w-100-percent full-width-divider"></mat-divider>
    <button class="accent mt-20 report-letter-spacing" type="button" (click)="matdialogRef.close()"> {{ 'BUTTONS.CLOSE' | transloco }} </button>
  </div>
  <mat-divider *ngIf="descriptionArray || errorArray || alertError" [ngStyle]="{ top: '10px' }" class="full-width-divider"></mat-divider>
  <div *ngIf="alertError" class="flex justify-end mr-8">
    <button class="accent mt-24 report-letter-spacing" type="button" (click)="matdialogRef.close()"> {{ 'BUTTONS.CLOSE' | transloco }} </button>
  </div>
  <div *ngIf="descriptionArray" class="flex flex-row justify-center items-center mt-24 ml-auto">
    <button class="white mr-20 report-letter-spacing" type="button" (click)="matdialogRef.close()"> {{ 'ERROR_DIALOG.BACK' | transloco }} </button>
    <button *ngIf="!hideReportButton" class="error-report-bg-color accent report-letter-spacing" type="button" (click)="openContactForm()"> {{ 'ERROR_DIALOG.REPORT' | transloco }} </button>
  </div>
  <div *ngIf="errorArray" class="flex flex-row justify-center items-center mt-24 ml-auto">
    <button class="white mr-20 report-letter-spacing" type="button" (click)="matdialogRef.close()"> {{ 'ERROR_DIALOG.BACK' | transloco }} </button>
    <button *ngIf="!hideReportButton" class="error-report-bg-color accent report-letter-spacing" type="button" (click)="openContactForm()"> {{ 'ERROR_DIALOG.REPORT' | transloco }} </button>
  </div>
  @if (errorDetails) {
    <div class="flex flex-row justify-center items-center mt-24">
      <button class="white mr-20 report-letter-spacing" type="button" (click)="matdialogRef.close('retry')"> {{ 'ERROR_DIALOG.RETRY' | transloco }} </button>
      <button class="error-report-bg-color accent report-letter-spacing" type="button" (click)="openContactForm()"> {{ 'ERROR_DIALOG.REPORT' | transloco }} </button>
    </div>
  }
}
</div>
